export const version = "transactions/5.1.0";
//# sourceMappingURL=_version.js.map